// extracted by mini-css-extract-plugin
module.exports = {"textAreaBox":"TextArea_textAreaBox__h3MgL"};